interface ProductImage {
  id: number;
  image: string;
}

interface ProductDemoGalleryProps {
  images: ProductImage[];
}

export default function ProductDemoGallery({ images }: ProductDemoGalleryProps) {
  if (!images || images.length === 0) return null;

  return (
    <div className="rounded-[32px] bg-white p-8 shadow-sm lg:p-10">
      <h3 className="mb-6 text-xl font-bold text-[#324A5A]">Profile Produk</h3>

      <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
        {images.map((img) => (
          <div
            key={img.id}
            className="
              group
              aspect-square

              overflow-hidden
              rounded-2xl

              bg-slate-50
            ">
            <img
              src={img.image}
              alt=""
              className="
                h-full
                w-full

                object-contain
                p-4

                transition-transform
                duration-300

                group-hover:scale-105
              "
            />
          </div>
        ))}
      </div>
    </div>
  );
}
